import { pickT } from "@repo/shared";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { T } from "./settings-custom-portfolio-form.i18n";

type SettingsCustomPortfolioFormProps = {
  flowLanguage: string;
  onlyAllowSuitable: boolean;
  onOnlyAllowSuitableChange: (allow: boolean) => void;
};

export function SettingsCustomPortfolioForm({
  flowLanguage,
  onlyAllowSuitable,
  onOnlyAllowSuitableChange,
}: SettingsCustomPortfolioFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <>
      {/* Suitability section - shown in Component Settings tab */}
      <div className="border-t pt-4 mt-4">
        <p className="text-sm font-medium mb-3">{t.suitability}</p>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="only-allow-suitable">{t.onlyAllowSuitable}</Label>
            <p className="text-xs text-muted-foreground">{t.onlyAllowSuitableDesc}</p>
          </div>
          <Switch
            id="only-allow-suitable"
            checked={onlyAllowSuitable}
            onCheckedChange={onOnlyAllowSuitableChange}
          />
        </div>
      </div>
    </>
  );
}

type SettingsCustomPortfolioFieldsFormProps = {
  flowLanguage: string;
  showIsin: boolean;
  onShowIsinChange: (show: boolean) => void;
  showProductType: boolean;
  onShowProductTypeChange: (show: boolean) => void;
};

export function SettingsCustomPortfolioFieldsForm({
  flowLanguage,
  showIsin,
  onShowIsinChange,
  showProductType,
  onShowProductTypeChange,
}: SettingsCustomPortfolioFieldsFormProps) {
  const t = pickT(T, flowLanguage);

  return (
    <>
      <p className="text-sm text-muted-foreground">{t.fieldsDescription}</p>
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="show-isin">{t.isin}</Label>
            <p className="text-xs text-muted-foreground">{t.isinDesc}</p>
          </div>
          <Switch id="show-isin" checked={showIsin} onCheckedChange={onShowIsinChange} />
        </div>
        <div className="flex items-center justify-between">
          <div className="space-y-0.5">
            <Label htmlFor="show-product-type">{t.productType}</Label>
            <p className="text-xs text-muted-foreground">{t.productTypeDesc}</p>
          </div>
          <Switch
            id="show-product-type"
            checked={showProductType}
            onCheckedChange={onShowProductTypeChange}
          />
        </div>
      </div>
    </>
  );
}
